import { MAX_FAVOURITES } from '../pickerLayout/constants';

export const canAddFavourite = (favourites) => favourites.length < MAX_FAVOURITES;
